import React, { createContext, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const PaymentContext = createContext();

const PaymentContextProvider = (props) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [filterStatus, setFilterStatus] = useState(searchParams.get('status') || 'none');
  const [filterDueDateFrom, setFilterDueDateFrom] = useState(() => {
    const val = searchParams.get('paymentDueDateFrom');
    return val ? new Date(val) : '';
  });
  const [filterDueDateTo, setFilterDueDateTo] = useState(() => {
    const val = searchParams.get('paymentDueDateTo');
    return val ? new Date(val) : '';
  });
  const [filterPaymentDateFrom, setFilterPaymentDateFrom] = useState(() => {
    const val = searchParams.get('paymentDateFrom');
    return val ? new Date(val) : '';
  });
  const [filterPaymentDateTo, setFilterPaymentDateTo] = useState(() => {
    const val = searchParams.get('paymentDateTo');
    return val ? new Date(val) : '';
  });
  return (
    <PaymentContext.Provider
      value={{
        filterStatus,
        setFilterStatus,
        filterDueDateFrom,
        setFilterDueDateFrom,
        filterDueDateTo,
        setFilterDueDateTo,
        filterPaymentDateFrom,
        setFilterPaymentDateFrom,
        filterPaymentDateTo,
        setFilterPaymentDateTo,
      }}
    >
      {props.children}
    </PaymentContext.Provider>
  );
};

export default PaymentContextProvider;
